import { useContext, useEffect } from 'react';
import { TeamContext } from '../services/Session';
import { ResponsiveContext } from 'grommet';

interface Props {
  show?: boolean;
}
const useZendeskWidget = ({ show = true }: Props = {}) => {
  const teamStore = useContext(TeamContext);
  const screenSize = useContext(ResponsiveContext);
  const teamId = teamStore.id || '';
  const isAdmin = teamStore.isTeamManager;

  const showWidget = () => {
    if (window.zE) {
      window.zE('messenger', 'show');
    }
  };

  const hideWidget = () => {
    if (window.zE) {
      window.zE('messenger', 'hide');
    }
  };

  const setConversationFields = (
    conversationFields: Record<string, string>[]
  ) => {
    if (window.zE) {
      window.zE('messenger:set', 'conversationFields', conversationFields);
    }
  };

  useEffect(() => {
    if (isAdmin && screenSize !== 'small' && show) {
      showWidget();
    } else {
      hideWidget();
    }

    return () => {
      hideWidget();
    };
  }, [screenSize, teamId, isAdmin, show]);

  return {
    showWidget,
    hideWidget,
    setConversationFields,
  };
};

export default useZendeskWidget;
